'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _treatInformation = require('./treat-information.html');

var _treatInformation2 = _interopRequireDefault(_treatInformation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _treatInformation2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    administrationUnits: '<',
    categories: '<',
    copyAreas: '<',
    onProductLabelChanged: '&',
    locked: '<',
    viewOnly: '<',
    product: '<',
    unitsDisplay: '<',
    onDateFirstSoldChanged: '&',
    showHeader: '<',
    labelValid: '<'
  },
  controller: function () {
    function TreatInformationComponent(EventEmitter) {
      'ngInject';

      _classCallCheck(this, TreatInformationComponent);

      Object.assign(this, { EventEmitter: EventEmitter });
    }

    _createClass(TreatInformationComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.labelChanged = false;
        this.maxDate = new Date();
      }
    }, {
      key: 'dateFirstSoldChanged',
      value: function dateFirstSoldChanged(dateFirstSold) {
        this.onDateFirstSoldChanged(this.EventEmitter({
          dateFirstSold: dateFirstSold
        }));
      }
    }, {
      key: 'productLabelChanged',
      value: function productLabelChanged(_ref) {
        var productLabel = _ref.productLabel;

        this.labelChanged = true;
        this.onProductLabelChanged(this.EventEmitter({
          productLabel: productLabel
        }));
      }
    }]);

    return TreatInformationComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/product/information/treat-information.component.js